import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { SettingsProvider } from "@/hooks/useSettings";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import Ankauf from "@/pages/Ankauf";
import Kontakt from "@/pages/Kontakt";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import Anfahrt from "@/pages/Anfahrt";
import UeberUns from "@/pages/UeberUns";
import LandingPage from "@/pages/landing/LandingPage";
import { landingSlugs } from "@/pages/landing/landingData";
import StylePreview from "@/pages/StylePreview";
import FontPreview from "@/pages/FontPreview";
import EffectsPreview from "@/pages/EffectsPreview";
import Portal from "@/pages/Portal";

// Legacy Shopify-URLs -> passende neue Seite (Fallback, falls kein 301 auf Server-Ebene greift)
const legacyRedirects = [
  ["/pages/impressum", "/recht/impressum"],
  ["/pages/datenschutz", "/recht/datenschutz"],
  ["/pages/agb", "/recht/agb"],
  ["/pages/widerruf", "/recht/widerruf"],
  ["/pages/ankauf-von-karten", "/ankauf"],
  ["/pages/uber-uns-shibuya-anime-amp-tcg-store", "/ueber-uns"],
  ["/pages/events", "/events"],
  ["/pages/cardwave-2025-das-sammelkarten-sommerfest", "/events"],
  ["/blogs/news", "/events"],
  ["/password", "/"],
];

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
      <Routes>
        <Route path="/preview" element={<StylePreview />} />
        <Route path="/preview-fonts" element={<FontPreview />} />
        <Route path="/preview-effects" element={<EffectsPreview />} />
        <Route path="/portal" element={<Portal />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<Events />} />
          <Route path="/tcg-events-koeln" element={<Navigate to="/events" replace />} />
          <Route path="/ankauf" element={<Ankauf />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/anfahrt" element={<Anfahrt />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          {landingSlugs.map((slug) => (
            <Route key={slug} path={`/${slug}`} element={<LandingPage slug={slug} />} />
          ))}
          <Route path="/admin" element={<Admin />} />
          <Route path="/impressum" element={<Navigate to="/recht/impressum" replace />} />
          <Route path="/datenschutz" element={<Navigate to="/recht/datenschutz" replace />} />
          <Route path="/agb" element={<Navigate to="/recht/agb" replace />} />
          <Route path="/widerruf" element={<Navigate to="/recht/widerruf" replace />} />
          <Route path="/recht/:page" element={<Legal />} />
          {legacyRedirects.map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
